module.exports = __webpack_public_path__ + "static/media/construction_white_on_purple_24dp.1d7a6129.svg";